import { render, staticRenderFns } from "./bidCustomer.vue?vue&type=template&id=8fc267da&scoped=true&lang=pug"
import script from "./bidCustomer.vue?vue&type=script&lang=js"
export * from "./bidCustomer.vue?vue&type=script&lang=js"
import style0 from "./bidCustomer.vue?vue&type=style&index=0&id=8fc267da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc267da",
  null
  
)

export default component.exports